<script setup lang="ts">
interface Props {
  cancelText?: string
  confirmText?: string
  confirmValidate?: boolean
  loading?: boolean
}

withDefaults(defineProps<Props>(), {
  cancelText: 'cancel',
  confirmText: 'confirm',
  loading: false,
})

const emit = defineEmits<{
  (e: 'cancel'): void
  (e: 'confirm'): void
}>()
</script>

<template>
  <div class="flex w-full gap-x-spacing-md">
    <SButton
      :text="$t(cancelText)"
      class="w-full border-2 border-primary-navyblue-800"
      @click="emit('cancel')" />
    <SButton
      :text="!loading ? $t(confirmText) : ''"
      :disabled="!confirmValidate || loading"
      class="w-full bg-accent-purple-400 text-white"
      @click="emit('confirm')">
      <Loading v-if="loading" size="size-8" />
    </SButton>
  </div>
</template>
